module.exports = __webpack_public_path__ + "e369e93a21abdf874bb5aa6e1b485f17.svg";